import React, { Component } from 'react';
import couterpart from 'counterpart';
import { withRouter } from 'react-router-dom'

import MenuComponent2 from './MenuComponent2';
import CardByStatus from './CardByStatus';
import CardByWorker from './CardByWorker';
import LayerOne from './LayerOne';
import LayerTwo from './LayerTwo';
import WorkerPlan from './WorkerPlan';
import MaterialList from './MaterialList';
import CardByDeadline from './CardByDeadline';
import CardByReprintTail from './CardByReprintTail';
import CardOrderByWorkOrderStatus from './CardOrderByWorkOrderStatus';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import UserDataService from '../services/UserDataService';

import AuthenticationService from '../services/AuthenticationService';
import MasterDataService from '../services/MasterDataService';
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import {
  WO_EXPORTED_CK,
  WO_COMPLETED_CK,
  WO_QUAYKIM,
  WO_XI,
  WO_SHIP_FROMVN,
  WO_TOBE_FIXED,
  WO_VOBAO,
  WO_READY,
  WO_ASSIGNED_WORKER,
  WO_ADMIN_APPROVED,
  WO_CHANGE_DESIGN,
  WO_DESIGN_APPROVED,
  WO_PRINT_TAIL,
  WO_DESIGN,
  WO_DESIGN_COMPLETE,
  WO_NHAM,
  WO_BONG,
  WO_CANCELLED,
  WO_KIEMTRA,
  WO_WAIT_FOR_INFO,
  ERROR_CODE_LOI_XI,
  WO_TOBE_FIXE_LOIXI,
  WO_TOBE_FIXE_ALL,
  WO_TOBE_FIXE_LOITHO,
  WO_DA_SHIP,
  WO_CHUA_SHIP,
  ERROR_CODE_COUNT_LOI_KHAC,
  ERROR_CODE_LOI_CAT_KHAC,
  ERROR_CODE_COUNT_LOI_CAT_KHAC,
  ERROR_CODE_COUNT_LOI_XI,
  WO_TOBE_FIXE_LOI_CATKHAC,
  STATUS_DA_HOAN_THANH,
  STATUS_SS_SX_DA,
  STATUS_DA_MOI,
  STATUS_LEN_MOI,
  STATUS_SS_SX_LEN,
  STATUS_LEN_HOAN_THANH,
  STATUS_NAME_DA,
  STATUS_NAME_LEN,
  STATUS_LEN_DA_SX,
  STATUS_DA_DA_SX,
  WO_HOANTHANH
} from '../constants';
import CardBySuco from './CardBySuco';
import CardByLenDaStatus from './CardByLenDaStatus';
import CardPrintTail from './CardPrintTail';
import CardRePrintTail from './CardRePrintTail';
import CardByDelivery from './CardByDelivery';
import CardByNonShipUs from './CardByNonShipUs';

class Dashboard extends Component {
  constructor() {
    super();
    this.state = {
      allStatus: [],
      workers: []
    };
  }

  loadWorker() {
    if (AuthenticationService.isAdmin() || AuthenticationService.isService() || AuthenticationService.isKhac() || AuthenticationService.isSupervisor()) {
      UserDataService.retrieveWorkers().then(data => {
        var len = data.length;
        var workers = [];
        for (var i = 0; i < len; i++) {
          workers.push({ key: data[i].id, label: data[i].firstName + data[i].lastName, value: data[i].id, userName: data[i].userName })
        }
        this.setState({ workers: workers });
      });
    }
  }

  clearShipOrders(){
    WorkOrderUtil.removeItem("shipOrders.fromDate")
    WorkOrderUtil.removeItem("shipOrders.toDate")
    WorkOrderUtil.removeItem("shipOrders.status")
    WorkOrderUtil.removeItem("shipOrders.shipTo")
    WorkOrderUtil.removeItem("shipOrders.customer")
    WorkOrderUtil.removeItem("shipOrders.orderNo")
    WorkOrderUtil.removeItem("shipOrders.woStatus")
    WorkOrderUtil.removeItem("shipOrders.woSubStatus")
    WorkOrderUtil.removeItem("shipOrders.pcode")
    WorkOrderUtil.removeItem("shipOrders.personalization")
    WorkOrderUtil.removeItem('shipOrders.selectedPage')
    WorkOrderUtil.removeItem('shipOrders.selectedRow')
    WorkOrderUtil.removeItem("shipOrders.selectedCountries");
    WorkOrderUtil.removeItem("shipOrders.selectedWoStatusList");
    WorkOrderUtil.removeItem("shipOrders.byDeadline");
    WorkOrderUtil.removeItem("shipOrders.fromDeadlineDate");
    WorkOrderUtil.removeItem("shipOrders.toDeadlineDate");
    WorkOrderUtil.removeItem("shipOrders.deadline");
    WorkOrderUtil.removeItem("shipOrders.page");
    WorkOrderUtil.removeItem("shipOrders.pageSize");
    WorkOrderUtil.removeItem("shipOrders.sortBy");
    WorkOrderUtil.removeItem("shipOrders.sortType");
    WorkOrderUtil.removeItem("shipOrders.reprintTail");
    WorkOrderUtil.removeItem("shipOrders.sku");
    WorkOrderUtil.removeItem("shipOrders.includeMau");
    WorkOrderUtil.removeItem("shipOrders.filterItemType");
    WorkOrderUtil.removeItem("shipOrders.urgent");
    WorkOrderUtil.removeItem("shipOrders.donMuaSearch");
    WorkOrderUtil.removeItem("shipOrders.hanGiaoMuaSearch");
    WorkOrderUtil.removeItem("shipOrders.hanGiaoMuaEndSearch");
    WorkOrderUtil.removeItem("shipOrders.filterGhiThiep");
    WorkOrderUtil.removeItem("shipOrders.ghiThiep");
  }

  clearKcsOrders(){
    WorkOrderUtil.removeItem("kcs.fromDate")
    WorkOrderUtil.removeItem("kcs.toDate")
    WorkOrderUtil.removeItem("kcs.status")
    WorkOrderUtil.removeItem("kcs.shipTo")
    WorkOrderUtil.removeItem("kcs.customer")
    WorkOrderUtil.removeItem("kcs.orderNo")
    WorkOrderUtil.removeItem("kcs.woStatus")
    WorkOrderUtil.removeItem("kcs.woSubStatus")
    WorkOrderUtil.removeItem("kcs.pcode")
    WorkOrderUtil.removeItem("kcs.personalization")
    WorkOrderUtil.removeItem('kcs.selectedPage')
    WorkOrderUtil.removeItem('kcs.selectedRow')
    WorkOrderUtil.removeItem("kcs.selectedCountries");
    WorkOrderUtil.removeItem("kcs.selectedWoStatusList");
    WorkOrderUtil.removeItem("kcs.deadline");
    WorkOrderUtil.removeItem("kcs.page");
    WorkOrderUtil.removeItem("kcs.pageSize");
    WorkOrderUtil.removeItem("kcs.sortBy");
    WorkOrderUtil.removeItem("kcs.sortType");
    WorkOrderUtil.removeItem("kcs.sku");
    WorkOrderUtil.removeItem("kcs.workerName");
    WorkOrderUtil.removeItem("kcs.hoanthanh");
  }

  componentDidMount() {
    this.clearShipOrders();
    this.clearShipWorkOrders();
    this.clearKcsOrders();

    WorkOrderUtil.removeItem('shipPackages.selectedShipCode');
    WorkOrderUtil.removeItem('shipPackages.selectedPage');
    WorkOrderUtil.removeItem('shipPackages.selectedRow');

    WorkOrderUtil.removeItem('errorList.selectedShipCode');
    WorkOrderUtil.removeItem('errorList.selectedPage');
    WorkOrderUtil.removeItem('errorList.selectedRow');


    WorkOrderUtil.removeItem("prod.fromDate")
    WorkOrderUtil.removeItem("prod.toDate")
    WorkOrderUtil.removeItem("prod.country");
    WorkOrderUtil.removeItem("prod.customer");
    WorkOrderUtil.removeItem("prod.orderNo");
    WorkOrderUtil.removeItem("prod.pcode")
    WorkOrderUtil.removeItem("prod.woStatus");
    WorkOrderUtil.removeItem("prod.deadline");
    WorkOrderUtil.removeItem("prod.selectedWoStatusList");
    WorkOrderUtil.removeItem("prod.semi");
    WorkOrderUtil.removeItem("prod.sku");
    WorkOrderUtil.removeItem("prod.includeImage");
    WorkOrderUtil.removeItem("prod.csReview");
    WorkOrderUtil.removeItem("prod.incident");
    WorkOrderUtil.removeItem("prod.store");
    WorkOrderUtil.removeItem("prod.personal");
    WorkOrderUtil.removeItem("prod.includeMau");
    WorkOrderUtil.removeItem("prod.filterItemType");
    WorkOrderUtil.removeItem("prod.personalization");
    WorkOrderUtil.removeItem("prod.urgent");
    WorkOrderUtil.removeItem("prod.donMuaSearch");
    WorkOrderUtil.removeItem("prod.hanGiaoMuaSearch");
    WorkOrderUtil.removeItem("prod.hanGiaoMuaEndSearch");
    WorkOrderUtil.removeItem("prod.ghiThiep");
    WorkOrderUtil.removeItem("prod.filterGhiThiep");
    WorkOrderUtil.removeItem("prod.ghiThiep");

    WorkOrderUtil.removeItem("products.selectedPage");
    WorkOrderUtil.removeItem("products.selectedRow");

    WorkOrderUtil.removeItem("orders.fromDate")
    WorkOrderUtil.removeItem("orders.toDate")
    WorkOrderUtil.removeItem("orders.status")
    WorkOrderUtil.removeItem("orders.country")
    WorkOrderUtil.removeItem("orders.customer")
    WorkOrderUtil.removeItem("orders.orderNo")
    WorkOrderUtil.removeItem("orders.woStatus")


    WorkOrderUtil.removeItem("wo.fromDate")
    WorkOrderUtil.removeItem("wo.toDate")
    WorkOrderUtil.removeItem("wo.fromDeadlineDate");
    WorkOrderUtil.removeItem("wo.status")
    WorkOrderUtil.removeItem("wo.country")
    WorkOrderUtil.removeItem("wo.customer")
    WorkOrderUtil.removeItem("wo.orderNo")
    WorkOrderUtil.removeItem("wo.woStatus")
    WorkOrderUtil.removeItem("wo.page")
    WorkOrderUtil.removeItem("wo.selected")
    WorkOrderUtil.removeItem("wo.includeImage")
    WorkOrderUtil.removeItem("wo.sku")
    WorkOrderUtil.removeItem("wo.pcode")
    WorkOrderUtil.removeItem("wo.onlyUrgent");
    WorkOrderUtil.removeItem("wo.donMuaSearch");
    WorkOrderUtil.removeItem("wo.hanGiaoMuaSearch");
    WorkOrderUtil.removeItem("wo.hanGiaoMuaEndSearch");

    WorkOrderUtil.removeItem("prodKhac.fromDate")
    WorkOrderUtil.removeItem("prodKhac.toDate")
    WorkOrderUtil.removeItem("prodKhac.orderNo")
    WorkOrderUtil.removeItem("prodKhac.woStatus")
    WorkOrderUtil.removeItem("prodKhac.workerName")
    WorkOrderUtil.removeItem("prodKhac.selectedWoStatusList");
    WorkOrderUtil.removeItem("prodKhac.semi");
    WorkOrderUtil.removeItem("prodKhac.pcode");
    WorkOrderUtil.removeItem("prodKhac.personalization");
    WorkOrderUtil.removeItem("prodKhac.sortBy");
    WorkOrderUtil.removeItem("prodKhac.sortType");
    WorkOrderUtil.removeItem("prodKhac.selected");
    WorkOrderUtil.removeItem('prodKhac.incident');
    WorkOrderUtil.removeItem("prodKhac.donMuaSearch");
    WorkOrderUtil.removeItem("prodKhac.hanGiaoMuaSearch");
    WorkOrderUtil.removeItem("prodKhac.hanGiaoMuaEndSearch");

    WorkOrderUtil.removeItem("lendas.fromDate")
    WorkOrderUtil.removeItem("lendas.toDate")
    WorkOrderUtil.removeItem("lendas.orderNo")
    WorkOrderUtil.removeItem("lendas.woStatus")
    WorkOrderUtil.removeItem("lendas.workerName")
    WorkOrderUtil.removeItem("lendas.selectedWoStatusList");
    WorkOrderUtil.removeItem("lendas.semi");
    WorkOrderUtil.removeItem("lendas.pcode");
    WorkOrderUtil.removeItem("lendas.personalization");
    WorkOrderUtil.removeItem("lendas.sortBy");
    WorkOrderUtil.removeItem("lendas.sortType");
    WorkOrderUtil.removeItem("lendas.selected");
    WorkOrderUtil.removeItem("lendas.lenStatus");
    WorkOrderUtil.removeItem("lendas.daStatus");

    WorkOrderUtil.removeItem("ckfiles.fromDate")
    WorkOrderUtil.removeItem("ckfiles.toDate")
    WorkOrderUtil.removeItem("ckfiles.woStatus")

    WorkOrderUtil.removeItem("superv.fromDate")
    WorkOrderUtil.removeItem("superv.toDate")
    WorkOrderUtil.removeItem("superv.orderNo")
    WorkOrderUtil.removeItem("superv.woStatus")
    WorkOrderUtil.removeItem("superv.workerName")
    WorkOrderUtil.removeItem("superv.selectedWoStatusList");
    WorkOrderUtil.removeItem("superv.semi");
    WorkOrderUtil.removeItem("superv.byDeadline");
    WorkOrderUtil.removeItem("superv.fromDeadlineDate");
    WorkOrderUtil.removeItem("superv.toDeadlineDate");
    WorkOrderUtil.removeItem("superv.deadline");
    WorkOrderUtil.removeItem("superv.selected");
    WorkOrderUtil.removeItem("superv.pcode");
    WorkOrderUtil.removeItem("superv.personalization");
    WorkOrderUtil.removeItem("superv.sortBy");
    WorkOrderUtil.removeItem("superv.sortType");
    WorkOrderUtil.removeItem("superv.reprintTail");
    WorkOrderUtil.removeItem("superv.sku");
    WorkOrderUtil.removeItem("superv.size");
    WorkOrderUtil.removeItem("superv.notPrintTail");
    WorkOrderUtil.removeItem("superv.notAssigned");
    WorkOrderUtil.removeItem("superv.notPrint");
    WorkOrderUtil.removeItem("superv.incident");
    WorkOrderUtil.removeItem("superv.woSubStatus");
    WorkOrderUtil.removeItem("superv.includeMau");

    this.clearSupervExt();
    this.clearQualityReport();
    this.clearProdKhacSearch();


    this.clearXi();

    MasterDataService.retrieveAllStatus().then(data => {
      this.setState({ allStatus: data })
    });

    this.loadWorker();
  }

  clearProdKhacSearch() {
    WorkOrderUtil.removeItem("prodKhacSearch.fromDate")
    WorkOrderUtil.removeItem("prodKhacSearch.toDate")
    WorkOrderUtil.removeItem("prodKhacSearch.orderNo")
    WorkOrderUtil.removeItem("prodKhacSearch.woStatus")
    WorkOrderUtil.removeItem("prodKhacSearch.workerName")
    WorkOrderUtil.removeItem("prodKhacSearch.selectedWoStatusList");
    WorkOrderUtil.removeItem("prodKhacSearch.semi");
    WorkOrderUtil.removeItem("prodKhacSearch.pcode");
    WorkOrderUtil.removeItem("prodKhacSearch.personalization");
    WorkOrderUtil.removeItem("prodKhacSearch.sortBy");
    WorkOrderUtil.removeItem("prodKhacSearch.sortType");
    WorkOrderUtil.removeItem("prodKhacSearch.selected");
    WorkOrderUtil.removeItem("prodKhacSearch.donMuaSearch");
    WorkOrderUtil.removeItem("prodKhacSearch.hanGiaoMuaSearch");
    WorkOrderUtil.removeItem("prodKhacSearch.hanGiaoMuaEndSearch");
  }

  clearQualityReport() {
    WorkOrderUtil.removeItem("qualityReport.fromDate");
    WorkOrderUtil.removeItem("qualityReport.toDate");
    WorkOrderUtil.removeItem("qualityReport.orderNo");
    WorkOrderUtil.removeItem("qualityReport.pcode");
    WorkOrderUtil.removeItem("qualityReport.pageSize");
    WorkOrderUtil.removeItem("qualityReport.page");
  }

  clearSupervExt(){
    WorkOrderUtil.removeItem("supervext.fromDate")
    WorkOrderUtil.removeItem("supervext.toDate")
    WorkOrderUtil.removeItem("supervext.orderNo")
    WorkOrderUtil.removeItem("supervext.woStatus")
    WorkOrderUtil.removeItem("supervext.workerName")
    WorkOrderUtil.removeItem("supervext.selectedWoStatusList");
    WorkOrderUtil.removeItem("supervext.semi");
    WorkOrderUtil.removeItem("supervext.byDeadline");
    WorkOrderUtil.removeItem("supervext.fromDeadlineDate");
    WorkOrderUtil.removeItem("supervext.toDeadlineDate");
    WorkOrderUtil.removeItem("supervext.deadline");
    WorkOrderUtil.removeItem("supervext.selected");
    WorkOrderUtil.removeItem("supervext.pcode");
    WorkOrderUtil.removeItem("supervext.personalization");
    WorkOrderUtil.removeItem("supervext.sortBy");
    WorkOrderUtil.removeItem("supervext.sortType");
    WorkOrderUtil.removeItem("supervext.reprintTail");
    WorkOrderUtil.removeItem("supervext.sku");
    WorkOrderUtil.removeItem("supervext.size");
    WorkOrderUtil.removeItem("supervext.notPrintTail");
    WorkOrderUtil.removeItem("supervext.notAssigned");
    WorkOrderUtil.removeItem("supervext.notPrint");
    WorkOrderUtil.removeItem("supervext.incident");
    WorkOrderUtil.removeItem("supervext.woSubStatus");
    WorkOrderUtil.removeItem("supervext.includeMau");
  }

  clearShipWorkOrders() {
    WorkOrderUtil.removeItem("shipWorkOrders.fromDate")
    WorkOrderUtil.removeItem("shipWorkOrders.toDate")
    WorkOrderUtil.removeItem("shipWorkOrders.status")
    WorkOrderUtil.removeItem("shipWorkOrders.shipTo")
    WorkOrderUtil.removeItem("shipWorkOrders.customer")
    WorkOrderUtil.removeItem("shipWorkOrders.orderNo")
    WorkOrderUtil.removeItem("shipWorkOrders.woStatus")
    WorkOrderUtil.removeItem("shipWorkOrders.woSubStatus")
    WorkOrderUtil.removeItem("shipWorkOrders.pcode")
    WorkOrderUtil.removeItem("shipWorkOrders.personalization")
    WorkOrderUtil.removeItem('shipWorkOrders.selectedPage', 1)
    WorkOrderUtil.removeItem('shipWorkOrders.selectedRow', 1)
    WorkOrderUtil.removeItem("shipWorkOrders.selectedCountries");
    WorkOrderUtil.removeItem("shipWorkOrders.selectedWoStatusList");

    WorkOrderUtil.removeItem("shipWorkOrders.byDeadline");
    WorkOrderUtil.removeItem("shipWorkOrders.fromDeadlineDate");
    WorkOrderUtil.removeItem("shipWorkOrders.toDeadlineDate");
    WorkOrderUtil.removeItem("shipWorkOrders.deadline");
    WorkOrderUtil.removeItem("shipWorkOrders.sku");
    WorkOrderUtil.removeItem("shipWorkOrders.filterItemType");
    WorkOrderUtil.removeItem("shipWorkOrders.urgent");
  }

  clearXi() {
    WorkOrderUtil.removeItem("prodXi.fromDate")
    WorkOrderUtil.removeItem("prodXi.toDate")
    WorkOrderUtil.removeItem("prodXi.orderNo")
    WorkOrderUtil.removeItem("prodXi.woStatus")
    WorkOrderUtil.removeItem("prodXi.workerName")
    WorkOrderUtil.removeItem("prodXi.selectedWoStatusList");
    WorkOrderUtil.removeItem("prodXi.semi");
    WorkOrderUtil.removeItem("prodXi.pcode");
    WorkOrderUtil.removeItem("prodXi.personalization");
    WorkOrderUtil.removeItem("prodXi.sortBy");
    WorkOrderUtil.removeItem("prodXi.sortType");
    WorkOrderUtil.removeItem("prodXi.selected");
    WorkOrderUtil.removeItem("prodXi.batchNo");
  }

  getStatusDescription(status) {
    if (this.state.allStatus === undefined || this.state.allStatus === null) {
      return status;
    }
    let istatus = parseInt(status);
    let statusInfo = this.state.allStatus.find(x => {
      return x.status === istatus;
    });
    if (statusInfo !== undefined) {
      return statusInfo.statusDescVn;
    }
    return status;
  }

  navToDetails(id) {
    if (AuthenticationService.isAdmin()) {
      this.props.history.push("/workOrders/edit/" + id + "?back=dashboard");
      return;
    }
    if (AuthenticationService.isService()) {
      this.props.history.push("/workOrders/service/" + id + "?back=dashboard");
      return;
    }
  }

  linkToDetails(wo) {
    return (
      <a href="#!" onClick={() => { this.navToDetails(wo.woId) }}>{wo.woNumber}</a>
    )
  }

  getColumnInfoByCategory() {
    return [{
      Header: couterpart.translate('work_order_id'),
      accessor: 'woNumber',
      Cell: row => (
        this.linkToDetails(row.original)
      )
    }, {
      Header: couterpart.translate('item_category'),
      accessor: 'category'
    }, {
      Header: couterpart.translate('order_no'),
      accessor: 'orderNumber'
    }, {
      Header: couterpart.translate('order_date'),
      accessor: 'orderDate'
    }, {
      Header: couterpart.translate('work_order_start_date'),
      accessor: 'startDate'
    }, {
      Header: couterpart.translate('work_order_web_deadline'),
      accessor: 'webDeadLine'
    }, {
      Header: couterpart.translate('work_order_prod_deadline'),
      accessor: 'prodDeadLine'
    }, {
      Header: couterpart.translate('work_order_status'),
      accessor: 'woStatus',
      width: 150,
      Cell: props => this.getStatusDescription(props.value)
    }, {
      Header: couterpart.translate('work_order_customer'),
      accessor: 'customer'
    }, {
      Header: couterpart.translate('work_order_quantity'),
      accessor: 'quantity'
    }, {
      Header: couterpart.translate('work_order_country'),
      accessor: 'country'
    }, {
      Header: couterpart.translate('work_order_urgent_level'),
      accessor: 'urgent'
    }, {
      Header: couterpart.translate('work_order_shiptime'),
      accessor: 'shipTime'
    }];
  }

  getColumnInfoByWorker() {
    return [{
      Header: couterpart.translate('work_order_id'),
      accessor: 'woNumber',
      Cell: row => (
        this.linkToDetails(row.original)
      )
    }, {
      Header: couterpart.translate('work_order_worker'),
      accessor: 'workerName'
    }, {
      Header: couterpart.translate('order_no'),
      accessor: 'orderNumber'
    }, {
      Header: couterpart.translate('order_date'),
      accessor: 'orderDate'
    }, {
      Header: couterpart.translate('work_order_start_date'),
      accessor: 'startDate'
    }, {
      Header: couterpart.translate('work_order_web_deadline'),
      accessor: 'webDeadLine'
    }, {
      Header: couterpart.translate('work_order_prod_deadline'),
      accessor: 'prodDeadLine'
    }, {
      Header: couterpart.translate('work_order_status'),
      accessor: 'woStatus',
      width: 150,
      Cell: props => this.getStatusDescription(props.value)
    }, {
      Header: couterpart.translate('work_order_customer'),
      accessor: 'customer'
    }, {
      Header: couterpart.translate('work_order_quantity'),
      accessor: 'quantity'
    }, {
      Header: couterpart.translate('work_order_country'),
      accessor: 'country'
    }, {
      Header: couterpart.translate('work_order_urgent_level'),
      accessor: 'urgent'
    }, {
      Header: couterpart.translate('work_order_shiptime'),
      accessor: 'shipTime'
    }];
  }

  getColumnInfoByUrgent() {
    return [{
      Header: couterpart.translate('work_order_id'),
      accessor: 'woNumber',
      Cell: row => (
        this.linkToDetails(row.original)
      )
    }, {
      Header: couterpart.translate('work_order_urgent_level'),
      accessor: 'urgent'
    }, {
      Header: couterpart.translate('work_order_worker'),
      accessor: 'workerName'
    }, {
      Header: couterpart.translate('order_no'),
      accessor: 'orderNumber'
    }, {
      Header: couterpart.translate('order_date'),
      accessor: 'orderDate'
    }, {
      Header: couterpart.translate('work_order_start_date'),
      accessor: 'startDate'
    }, {
      Header: couterpart.translate('work_order_web_deadline'),
      accessor: 'webDeadLine'
    }, {
      Header: couterpart.translate('work_order_prod_deadline'),
      accessor: 'prodDeadLine'
    }, {
      Header: couterpart.translate('work_order_status'),
      accessor: 'woStatus',
      width: 150,
      Cell: props => this.getStatusDescription(props.value)
    }, {
      Header: couterpart.translate('work_order_customer'),
      accessor: 'customer'
    }, {
      Header: couterpart.translate('work_order_quantity'),
      accessor: 'quantity'
    }, {
      Header: couterpart.translate('work_order_country'),
      accessor: 'country'
    }, {
      Header: couterpart.translate('work_order_shiptime'),
      accessor: 'shipTime'
    }];
  }

  renderWorkerCard(worker) {
    return (
      <Col xs={4} md={3} key={worker.userName}> 
        <CardByWorker key={worker.userName}
          allStatus={this.state.allStatus}
          info={{
            workerName: worker.userName,
            worker: worker.key,
            statusList: [WO_ASSIGNED_WORKER, WO_COMPLETED_CK, WO_READY, WO_NHAM]
          }} />
      </Col>
    )
  }

  renderWorkers() {
    if (this.state.workers === undefined || this.state.workers === null) {
      return (<></>);
    }
    return (
      <>{this.state.workers.map(woker => this.renderWorkerCard(woker))}</>
    );
  }

  render() {
    if (!AuthenticationService.isAdmin() && 
      !AuthenticationService.isService() &&
      !AuthenticationService.isQuality() &&
      !AuthenticationService.isDelivery() &&
      !AuthenticationService.isDesigner() &&
      !AuthenticationService.isShipping() &&
      !AuthenticationService.isKhac() &&
      !AuthenticationService.isKim() &&
      !AuthenticationService.isBong() &&
      !AuthenticationService.isKcs() &&
      !AuthenticationService.isNham() &&
      !AuthenticationService.isSupervisor() &&
      !AuthenticationService.isWorker() &&
      !AuthenticationService.isXi()) {
      return (<div>Unauthorized access.</div>);
    }

    if (AuthenticationService.isService()) {
      return (
        <div className="dashboard-container">
          <MenuComponent2 />
          <Container fluid >
            <Row className="show-grid">
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_WAIT_FOR_INFO
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_DESIGN
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_CHANGE_DESIGN
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_DESIGN_COMPLETE
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_DESIGN_APPROVED
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_KIEMTRA
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_CANCELLED
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByDeadline btn="yes" />
              </Col>
            </Row>
          </Container>
        </div>
      );
    } else if (AuthenticationService.isAdmin()) {
      return (
        <div className="dashboard-container">
          <MenuComponent2 />
          <Container fluid >
            <Row className="show-grid">
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_DESIGN
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_CHANGE_DESIGN
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_DESIGN_COMPLETE
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_DESIGN_APPROVED
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_ADMIN_APPROVED
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_EXPORTED_CK
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_ASSIGNED_WORKER
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_READY
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_PRINT_TAIL
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_COMPLETED_CK
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_NHAM
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_BONG
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_QUAYKIM
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_XI
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_TOBE_FIXED
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByDeadline />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_KIEMTRA
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardBySuco btn="no" />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_CANCELLED
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_HOANTHANH
                  }} />
              </Col>
            </Row>
          </Container>
        </div>
      );
    } else if (AuthenticationService.isKhac()) {
      return (
        <div className="dashboard-container">
          <MenuComponent2 />
          <Container fluid >
            <Row className="show-grid">
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_COMPLETED_CK
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_READY
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_ASSIGNED_WORKER
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  title="Lỗi Khắc"
                  error={{
                    errorCode: ERROR_CODE_COUNT_LOI_CAT_KHAC
                  }}
                  info={{
                    status: WO_TOBE_FIXED
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardBySuco btn="no" />
              </Col>
              <Col xs={4} md={3}>
                <CardRePrintTail btn="no" reprintTail={1} deadline={0} />
              </Col>
            </Row>
            <div className="row">
              <WorkerPlan />
            </div>
          </Container>
        </div>
      );
    } else if (AuthenticationService.isSupervisor()) {
      return (
        <div className="dashboard-container">
          <MenuComponent2 />
          <div className="row">
            <LayerOne></LayerOne>
          </div>
          <div className="row">
            <div className="col-1"></div>
            <div className="col-2">Đã phân công thợ
            </div>
          </div>
          <div className="row">
            <div className="col-2"></div>
            <div className="col-2">
              <LayerTwo
                styleInfo={'button-g'}
                title={'Đã chia thợ'}
                allStatus={this.state.allStatus}
                info={{
                  status: WO_ASSIGNED_WORKER,
                  assigned: 1,
                  semi: 1
                }} />
            </div>
            <div className="col-1"></div>
            <div className="col-2">
              <LayerTwo
                styleInfo={'button-g'}
                title={'Sẵn sàng cho CK'}
                allStatus={this.state.allStatus}
                info={{
                  status: WO_READY,
                  assigned: 1,
                  semi: -1
                }} />
            </div>
            <div className="col-1"></div>
            <div className="col-2">
              <LayerTwo
                styleInfo={'button-g'}
                title={'All'}
                allStatus={this.state.allStatus}
                info={{
                  statusList: [WO_ASSIGNED_WORKER, WO_READY],
                  assigned: 1,
                  semi: -1
                }} />
            </div>
          </div>
          <div className="row">
            <div className="col-1"></div>
            <div className="col-2">
              Chưa phân công thợ { /* WorkOrderUtil.getStatusDescription(this.state.allStatus, WO_EXPORTED_CK) */}
            </div>
            <div className="col-1"></div>
          </div>
          <div className="row">
            <div className="col-2"></div>
            <div className="col-2">
              <LayerTwo
                styleInfo={'button-r'}
                title={'Semi'}
                allStatus={this.state.allStatus}
                info={{
                  status: WO_EXPORTED_CK,
                  assigned: 0,
                  semi: 1
                }} />
            </div>
            <div className="col-1"></div>
            <div className="col-2">
              <LayerTwo
                styleInfo={'button-r'}
                title={'Không semi'}
                allStatus={this.state.allStatus}
                info={{
                  status: WO_EXPORTED_CK,
                  assigned: 0,
                  semi: 0
                }} />
            </div>
            <div className="col-1"></div>
            <div className="col-2">
              <LayerTwo
                styleInfo={'button-g'}
                title={'All'}
                allStatus={this.state.allStatus}
                info={{
                  status: WO_EXPORTED_CK,
                  assigned: 0,
                  semi: -1
                }} />
            </div>
          </div>
          <div className="row" style={{ backgroundColor: "#d3d3d3"}}>
            <div className="col-3">
              <LayerTwo
                styleInfo={'button-w'}
                title={WorkOrderUtil.getStatusDescription(this.state.allStatus, WO_READY)}
                allStatus={this.state.allStatus}
                info={{
                  status: WO_READY
                }} />
            </div>
            <div className="col-3">
              <LayerTwo
                styleInfo={'button-w'}
                title={WorkOrderUtil.getStatusDescription(this.state.allStatus, WO_COMPLETED_CK)}
                allStatus={this.state.allStatus}
                info={{
                  status: WO_COMPLETED_CK
                }} />
            </div>
            <div className="col-3">
              <CardByDeadline btn="no" />
            </div>
          </div>
          <div className="row" style={{ backgroundColor: "#d3d3d3"}}>        
            <div className="col-3">
              <CardBySuco btn="no" />
            </div>
            <div className="col-3">
              <CardOrderByWorkOrderStatus  btn="no" 
                allStatus={this.state.allStatus}
                info={{
                  status: WO_TOBE_FIXED,
                  subStatus: WO_TOBE_FIXE_LOIXI,
                  errorFilter: WO_TOBE_FIXE_LOIXI
                }} />
            </div>
            <div className="col-3">
              <CardOrderByWorkOrderStatus  btn="no" 
                allStatus={this.state.allStatus}
                info={{
                  status: WO_TOBE_FIXED,
                  subStatus: WO_TOBE_FIXE_LOITHO,
                  errorFilter: WO_TOBE_FIXE_LOITHO
                }} />
            </div>
            <div className="col-3">
              <CardOrderByWorkOrderStatus  btn="no" 
                allStatus={this.state.allStatus}
                info={{
                  status: WO_TOBE_FIXED,
                  subStatus: WO_TOBE_FIXE_LOI_CATKHAC,
                  errorFilter: WO_TOBE_FIXE_LOI_CATKHAC
                }} />
            </div>
          </div>
          <div className="row">
            <Container fluid >
              <Row className="show-grid">
                {this.renderWorkers()}
              </Row>
            </Container>
          </div>
          <div className="row">
            <WorkerPlan />
          </div>
          <div style={{ width: "100%" }}>
            <MaterialList />
          </div>

        </div>
      );
    } else if (AuthenticationService.isShipping()) {
      return (
        <div className="dashboard-container">
          <MenuComponent2 />
          <Container fluid >
            <Row className="show-grid">
              <Col xs={4} md={3}>
                <CardOrderByWorkOrderStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_XI
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardOrderByWorkOrderStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_QUAYKIM
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardOrderByWorkOrderStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_TOBE_FIXED,
                    subStatus: 0,
                    errorFilter: WO_TOBE_FIXE_LOIXI
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardOrderByWorkOrderStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_TOBE_FIXED,
                    subStatus: 0,
                    errorFilter: WO_TOBE_FIXE_LOITHO
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardOrderByWorkOrderStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_TOBE_FIXED,
                    subStatus: 0,
                    errorFilter: WO_TOBE_FIXE_LOI_CATKHAC
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardOrderByWorkOrderStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_TOBE_FIXED,
                    subStatus: 0,
                    errorFilter: WO_TOBE_FIXE_ALL
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardOrderByWorkOrderStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_VOBAO
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardOrderByWorkOrderStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_SHIP_FROMVN,
                    subStatus: WO_CHUA_SHIP,
                    errorFilter: 0
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardOrderByWorkOrderStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_SHIP_FROMVN,
                    subStatus: WO_DA_SHIP,
                    errorFilter: 0
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByDeadline btn="yes" />
              </Col>
              <Col xs={4} md={3}>
                <CardByReprintTail btn="no" reprintTail={1} deadline={0} />
              </Col>
              <Col xs={4} md={3}>
                <CardPrintTail btn="no" reprintTail={1} deadline={0} />
              </Col>
            </Row>
          </Container>
        </div>
      );
    } else if (AuthenticationService.isDesigner()) {
      return (
        <div className="dashboard-container">
          <MenuComponent2 />
          <Container fluid >
            <Row className="show-grid">
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_DESIGN
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_CHANGE_DESIGN
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_DESIGN_COMPLETE
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_EXPORTED_CK
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_ADMIN_APPROVED
                  }} />
              </Col>
            </Row>
          </Container>
        </div>
      );
    } else if (AuthenticationService.isKim()) {
      return (
        <div className="dashboard-container">
          <MenuComponent2 />
          <Container fluid >
            <Row className="show-grid">
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_BONG
                  }} />
              </Col>
            </Row>
          </Container>
        </div>
      );
    } else if (AuthenticationService.isXi()) {
      return (
        <div className="dashboard-container">
          <MenuComponent2 />
          <Container fluid >
            <Row className="show-grid">
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_QUAYKIM
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_XI
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  title="Lỗi Xi"
                  error={{
                    errorCode: ERROR_CODE_COUNT_LOI_XI
                  }}
                  info={{
                    status: WO_TOBE_FIXED
                  }} />
              </Col>
            </Row>
          </Container>
        </div>
      );
    } else if (AuthenticationService.isBong()) {
      return (
        <div className="dashboard-container">
          <MenuComponent2 />
          <Container fluid >
            <Row className="show-grid">
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_COMPLETED_CK
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_NHAM
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_BONG
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  title="Lỗi Khác"
                  error={{
                    errorCode: ERROR_CODE_COUNT_LOI_KHAC
                  }}
                  info={{
                    status: WO_TOBE_FIXED
                  }} />
              </Col>
            </Row>
          </Container>
        </div>
      );
    } else if (AuthenticationService.isLen()) {
      return (
        <div className="dashboard-container">
          <MenuComponent2 />
          <Container fluid >
            <Row className="show-grid">
              <Col xs={4} md={3}>
                <CardByLenDaStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: STATUS_SS_SX_LEN,
                    lenDa: 1,
                    statusName: STATUS_NAME_LEN
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByLenDaStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: STATUS_LEN_DA_SX,
                    lenDa: 1,
                    statusName: STATUS_NAME_LEN
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByLenDaStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: STATUS_LEN_HOAN_THANH,
                    lenDa: 1,
                    statusName: STATUS_NAME_LEN
                  }} />
              </Col>
            </Row>
          </Container>
        </div>
      );
    } else if (AuthenticationService.isDa()) {
      return (
        <div className="dashboard-container">
          <MenuComponent2 />
          <Container fluid >
            <Row className="show-grid">
              <Col xs={4} md={3}>
                <CardByLenDaStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: STATUS_SS_SX_DA,
                    lenDa: 1,
                    statusName: STATUS_NAME_DA
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByLenDaStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: STATUS_DA_DA_SX,
                    lenDa: 1,
                    statusName: STATUS_NAME_DA
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByLenDaStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: STATUS_DA_HOAN_THANH,
                    lenDa: 1,
                    statusName: STATUS_NAME_DA
                  }} />
              </Col>
            </Row>
          </Container>
        </div>
      );
    }  else if (AuthenticationService.isQuality()) {
      return (
        <div className="dashboard-container">
          <MenuComponent2 />
          <Container fluid >
            <Row className="show-grid">
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_TOBE_FIXED
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardOrderByWorkOrderStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_SHIP_FROMVN,
                    subStatus: WO_DA_SHIP,
                    errorFilter: 0
                  }} />
              </Col>
            </Row>
          </Container>
        </div>
      );
    } else if (AuthenticationService.isDelivery()) {
      return (
        <div className="dashboard-container">
          <MenuComponent2 />
          <Container fluid >
            <Row className="show-grid">
              <Col xs={4} md={3}>
                <CardByDelivery />
              </Col>
              <Col xs={4} md={3}>
                <CardByNonShipUs />
              </Col>
            </Row>
          </Container>
        </div>
      );
    } else if (AuthenticationService.isKcs()) {
      return (
        <div className="dashboard-container">
          <MenuComponent2 />
          <Container fluid >
            <Row className="show-grid">
              <Col xs={4} md={3}>
                <CardByStatus
                  title='Bóng cần làm dây'
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_BONG,
                    hoanthanh: 1
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  title='Bóng khác'
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_BONG,
                    hoanthanh: 2
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: WO_HOANTHANH
                  }} />
              </Col>
            </Row>
          </Container>
        </div>
      );
    } else {
      return (
        <div className="dashboard-container">
          <MenuComponent2 />
          <Container fluid >
            <Row className="show-grid">
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: 32
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: 34
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: 35
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: 50
                  }} />
              </Col>
              <Col xs={4} md={3}>
                <CardByStatus
                  allStatus={this.state.allStatus}
                  info={{
                    status: 48
                  }} />
              </Col>
            </Row>
          </Container>
        </div>
      );
    }
  }
}

export default withRouter(Dashboard);
